import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-gtm-action", "data-gtm-label"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "accordion__icon" }, null, -1)
const _hoisted_3 = { class: "accordion__body accordion__body--has-icon" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.coverage)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['accordion__item', { 'accordion__item--open': _ctx.coverage.selected }])
      }, [
        _createElementVNode("div", {
          class: "accordion__header accordion__header--track_covered",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.animateController())),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.animateController()), ["enter"])),
          role: "button",
          tabindex: "0",
          "data-gtm-action": _ctx.trackGtm ? 'Accordion' : null,
          "data-gtm-label": _ctx.getTrackGtmLabel()
        }, [
          _hoisted_2,
          _createElementVNode("h3", {
            class: _normalizeClass(['accordion__headline', { 'accordion__headline--track_covered': _ctx.track }])
          }, _toDisplayString(_ctx.coverage.name), 3)
        ], 40, _hoisted_1),
        (_openBlock(), _createBlock(_Transition, {
          name: "slide",
          key: _ctx.coverage.featureId
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                innerHTML: _ctx.coverage?.description,
                class: "mb-3 coverage__description"
              }, null, 8, _hoisted_4)
            ], 512), [
              [_vShow, _ctx.coverage.selected]
            ])
          ]),
          _: 1
        }))
      ], 2))
    : _createCommentVNode("", true)
}